<template>
  <div>
  <h2 class="ccc">Viewing Trace</h2>
  <div>Open a trace file using upload button (
    <el-button size="mini" icon="el-icon-upload"></el-button>
    ) located at the header, or drag and drop it from file system.
  </div>
  <div class="section mt-3">
    After you open trace file, following view appears:
  </div>
  <div>
    <img style="width: 1000px" class="img-fluid" src="../../assets/pytrace-ui.png" alt="pytrace user interface"/>
  </div>
  <div class="section mt-3">
    You can use slider to scroll through the trace events.
    Inspector panel will show variables recorded at particular line
  </div>
  <h5 class="mt-3">Stepping through code</h5>
  <div class="section mt-2 mb-5">
    <div class="section__line mb-4">You can navigate through replay by clicking on debugger-like toolbar buttons or
      their corresponding hotkeys:
    </div>
    <div>
      <el-button size="small" icon="el-icon-arrow-up" class="mr-3" title="(Shift+↑) Step Out Back"></el-button>
      <pc-hotkey shift>Up Arrow</pc-hotkey>
      Step Out Back - Exits from function to the line where it was called
    </div>
    <div>
      <el-button size="small" icon="el-icon-caret-top" class="mr-3" title="(↑) Step Over Back"></el-button>
      <pc-hotkey>Up Arrow</pc-hotkey>
      Step Over Back - Go back to the previous line in current function (ignoring other calls)
    </div>
    <div>
      <el-button size="mini" icon="el-icon-caret-left" class="mr-3" title="(←) Back"></el-button>
      <pc-hotkey>Left Arrow</pc-hotkey>
      Go to the previous event in code-execution time-space
    </div>
    <div>
      <el-button size="mini" icon="el-icon-caret-right" class="mr-3" title="(→) Forward"></el-button>
      <pc-hotkey>Right Arrow</pc-hotkey>
      Go to the next event (Step Into or Step Over; depending on code under cursor)
    </div>
    <div>
      <el-button size="mini" icon="el-icon-caret-bottom" class="mr-3" title="(↓) Step over"></el-button>
      <pc-hotkey>Down Arrow</pc-hotkey>
      Step Over, ignoring calls to other functions
    </div>
    <div>
      <el-button size="small" icon="el-icon-arrow-down" class="mr-3" title="(Shift+ ↓) Step Out Forward"></el-button>
      <pc-hotkey shift>Down Arrow</pc-hotkey>
      Step Out - Go to parent function
    </div>
    <div class="text-secondary mt-3">Hint: hover over toolbar buttons throughout the app to learn their hotkeys.</div>
  </div>
  <h5 class="mt-3">Using flame graph to navigate around</h5>
  <div class="section mt-3 mb-5">
    <div class="section__line">The fastest way to navigate around is to use Graph Canvas. It can be accessed by pressing
      <pc-hotkey>G</pc-hotkey>
      hotkey on keyboard.
    </div>
    <div class="section__line">(alternatively you can click on settings button in header and enable Graph Canvas from
      there):
    </div>
    <div class="section__line">
      <img src="../../assets/pytrace-settings-menu.png" alt="Setting menu" height="418">
    </div>
  </div>
  <div class="section mt-3 mb-5">
    <div>Call graph open:</div>
    <img src="../../assets/pytrace-graph-view.png" class="img-fluid" alt="pytrace-graph-view" width="1228">
  </div>
  <h5 class="mt-3">Interacting with a graph</h5>
  <pc-graph-hotkeys/>
  </div>
</template>
<script>
  import PcGraphHotkeys from './PcGraphHotkeys'
  import PcHotkey from './hotkey.component'

  export default {
    name: 'pc-viewing-trace-doc',
    components: {
      PcGraphHotkeys,
      PcHotkey,
    },
  }
</script>